import { useEffect, useState } from "react";
import { ThumbNailImg } from "../../shared/icons";
import Layout from "../../components/layout";
import NftDetailMidSection from "./NftDetailMidSection";
import TestimonialSection from "./TestimonialSection";
import NftHeroSection from "./NftHeroSection";
import { useParams } from "react-router-dom";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";
import { getNFTDetails } from "../../slices/nftDetails/nftDetailsThunks";
import { Loading, NFTDetails } from "./Types";
import AISearchBar from "../../components/shared-components/AISearchInput";
import { searchNFTsAndCollections } from "../../slices/home/homeThunks";

const NftDetails = () => {
  const { id } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [nftDetails, setNftDetails] = useState<NFTDetails | null>(null);
  const [isLoading, setIsLoading] = useState<Loading>({
    nftDetails: false,
  });
  const [isSearchLoading, setIsSearchLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<any>([]);
  const [collectionId, setCollectionId] = useState(null);
  const handleSearch = (query: string) => {
    if(!query.length) {
      return;
    }
    setIsSearchLoading(true);
    dispatch(searchNFTsAndCollections({ keyword: query, limit: 5 }))
      .then((res: any) => {
        if (res?.error) {
          throw new Error(res?.payload);
        }
        const combinedData =
          res?.payload?.data?.data?.combinedData?.map((item: any) => ({
            id: item?._id,
            chain: item?.chain,
            name: item?.name,
            imageUrl: item?.featureImage || item?.fileUrl,
            score: item?.score || 0,
            price: (parseFloat(item?.floorPrice || 0).toFixed(4)),
            networkId: item?.networkId || 1,
            type: item?.assetType
          }));
        setSearchResults(combinedData);
      })
      .catch((err) => {
        setSearchResults([]);
      })
      .finally(() => {
        setIsSearchLoading(false);
      });
  };

  useEffect(() => {
    getNFTDetailsRecord();
  }, []);

  useEffect(() => {
    if (id) {
      window.scrollTo(0, 0);
    }
  }, [id]);

  const getNFTDetailsRecord = () => {
    setIsLoading((prev: any) => ({ ...prev, nftDetails: true }));
    dispatch(getNFTDetails(id))
      .then((res: any) => {
        if (res?.error) {
          throw new Error(res?.payload);
        }
        const nft = res?.payload?.data?.data;
        setCollectionId(res?.payload?.data?.data?.collectionId);
        const mappedNFTDetails = {
          id: nft?._id,
          featureImage: nft?.fileUrl || ThumbNailImg,
          name: nft?.name || "--",
          creator: nft?.creator || "--",
          owner: nft?.owner || "--",
          description: nft?.description || "--",
          networkId: nft?.networkId || 1,
          createdBy: nft?.createdBy,
          externalLink: nft?.externalLink,
          score: nft?.score,
          price: nft?.price,
          isActive: nft?.isActive
        };
        setNftDetails(mappedNFTDetails);
      })
      .catch((err) => {
        console.log({err})
      })
      .finally(() => {
        setIsLoading((prev: any) => ({ ...prev, nftDetails: false }));
      });
  };

  return (
    <Layout fullScreen>
      <NftHeroSection
        nftDetails={nftDetails}
        isLoading={isLoading?.nftDetails}
        getNFTDetailsRecord={getNFTDetailsRecord}
      />
      <AISearchBar
        isHeaderSearch
        handleSearch={handleSearch}
        isLoading={isSearchLoading}
        searchResults={searchResults}
        placeholder="Search for digital assets or users"
      />
      <NftDetailMidSection
        collectionId={collectionId}
        name={nftDetails?.name}
        score={nftDetails?.score}
        networkId={nftDetails?.networkId || 1}
      />
      <TestimonialSection />
      {/* <PaymentHistory /> */}
    </Layout>
  );
};

export default NftDetails;
